// Next Diamonds — Mobile filter UX
// 1. Sticky pill FAB (Filter only)
// 2. Sort chips above the grid
// 3. Tab-strip inside the bottom sheet — one filter group at a time
// 4. Sticky Clear/Apply bar inside the sheet
//
// Notes on Symmetry's markup:
//   - Two forms live inside .filter-container .filters:
//       #CollectionFilterFormSkeleton  (loading state, .skeleton class)
//       #CollectionFilterForm          (real form, hidden initially)
//   - The real form is populated AJAX-style; filter groups appear inside
//     once Symmetry has fetched filter data. We use a MutationObserver
//     to detect when real groups appear, then tabify.

(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 999.98;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  // ===============================================================
  // Sort chips above the grid
  // ===============================================================

  function findSortSelect() {
    return document.querySelector('select.toolbar__sort, select[name="sort_by"]');
  }

  function findGridAnchor() {
    return (
      document.querySelector('.utility-bar') ||
      document.querySelector('.product-grid, .product-list, [data-section-type="collection"] .container') ||
      null
    );
  }

  function buildSortChips() {
    if (!isMobile()) return;
    var select = findSortSelect();
    if (!select) return;
    var existing = document.querySelector('.nd-sort-chips');
    if (existing) existing.remove();

    var row = document.createElement('div');
    row.className = 'nd-sort-chips';

    Array.prototype.forEach.call(select.options, function (opt) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'nd-sort-chip';
      chip.dataset.value = opt.value;
      chip.textContent = opt.textContent.trim();
      if (opt.selected) chip.classList.add('is-active');
      chip.addEventListener('click', function () {
        if (select.value === opt.value) return;
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        row.querySelectorAll('.nd-sort-chip').forEach(function (c) {
          c.classList.toggle('is-active', c === chip);
        });
      });
      row.appendChild(chip);
    });

    var anchor = findGridAnchor();
    if (!anchor) return;
    if (anchor.classList.contains('utility-bar')) {
      anchor.parentNode.insertBefore(row, anchor.nextSibling);
    } else {
      anchor.parentNode.insertBefore(row, anchor);
    }
  }

  // ===============================================================
  // Tabify the real filter form (NOT the skeleton)
  // ===============================================================

  function findRealForm() {
    return (
      document.getElementById('CollectionFilterForm') ||
      document.querySelector('.filter-container .filters form:not(.skeleton)')
    );
  }

  function findRealGroups(form) {
    if (!form) return [];
    var nodes = form.querySelectorAll('.filter-group');
    var out = [];
    nodes.forEach(function (g) {
      if (g.classList.contains('filter-group--applied')) return;
      // Only count groups that actually have items (skip empty/placeholder)
      if (!g.querySelector('input, .filter-group__item, .cc-price-range')) return;
      out.push(g);
    });
    return out;
  }

  function getGroupLabel(group) {
    var heading =
      group.querySelector('.filter-group__heading') ||
      group.querySelector('.heading-font') ||
      group.querySelector('h2, h3, h4, legend');
    if (heading) return heading.textContent.replace(/\s+/g, ' ').trim();
    var id = group.id || '';
    return id.replace(/^filter-group-/, '').replace(/-/g, ' ')
             .replace(/\b./, function (m) { return m.toUpperCase(); }) || 'Filter';
  }

  function getActiveCountForGroup(group) {
    var n = 0;
    group.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(function (i) {
      if (i.name && i.name.indexOf('filter') === 0) n++;
    });
    var priceInputs = group.querySelectorAll('.cc-price-range__input');
    var priceSet = false;
    priceInputs.forEach(function (i) { if (i.value && i.value.trim()) priceSet = true; });
    if (priceSet) n++;
    return n;
  }

  // Module-level refs so refreshTabCounts can update the strip on input change
  var currentStrip = null;
  var currentGroups = null;

  function tabify() {
    if (!isMobile()) return false;
    var container = document.querySelector('.filter-container');
    if (!container) return false;
    var form = findRealForm();
    if (!form) return false;
    var groups = findRealGroups(form);
    if (!groups.length) return false;

    // Clean up any prior strip and active flags
    var prev = container.querySelector('.nd-tab-strip');
    if (prev) prev.remove();
    groups.forEach(function (g) { g.removeAttribute('data-nd-active'); });

    var strip = document.createElement('div');
    strip.className = 'nd-tab-strip';
    currentStrip = strip;
    currentGroups = groups;

    groups.forEach(function (group, i) {
      var label = getGroupLabel(group);
      var count = getActiveCountForGroup(group);

      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'nd-tab';
      tab.dataset.ndTabIndex = i;
      tab.innerHTML =
        '<span>' + label + '</span>' +
        (count > 0 ? '<span class="nd-tab__count">' + count + '</span>' : '');

      if (i === 0) {
        tab.classList.add('is-active');
        group.setAttribute('data-nd-active', '');
      }

      tab.addEventListener('click', function () {
        strip.querySelectorAll('.nd-tab').forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        groups.forEach(function (g) { g.removeAttribute('data-nd-active'); });
        group.setAttribute('data-nd-active', '');
        // Reset the sheet's scroll so each tab starts at the top — keeps the
        // first row of items in a consistent vertical position across tabs.
        var scrollable = document.querySelector('.filter-container .filters__inner');
        if (scrollable) scrollable.scrollTop = 0;
      });

      strip.appendChild(tab);
    });

    // Insert strip as the first child of the form
    form.insertBefore(strip, form.firstChild);
    container.classList.add('nd-filter-tabbed');
    return true;
  }

  // Update the tab badges live as the user toggles filter inputs in the sheet
  function refreshTabCounts() {
    if (!currentStrip || !currentGroups) return;
    var tabs = currentStrip.querySelectorAll('.nd-tab');
    tabs.forEach(function (tab, i) {
      var group = currentGroups[i];
      if (!group) return;
      var count = getActiveCountForGroup(group);
      var badge = tab.querySelector('.nd-tab__count');
      if (count > 0) {
        if (badge) {
          badge.textContent = count;
        } else {
          var b = document.createElement('span');
          b.className = 'nd-tab__count';
          b.textContent = count;
          tab.appendChild(b);
        }
      } else if (badge) {
        badge.remove();
      }
    });
  }

  // Watch for the real form to populate (it's empty until Symmetry's AJAX
  // finishes). Once filter groups appear, tabify and stop observing.
  function watchForFilterGroups() {
    var filters = document.querySelector('.filter-container .filters');
    if (!filters) return;
    if (tabify()) return;
    var mo = new MutationObserver(function () {
      if (tabify()) {
        mo.disconnect();
      }
    });
    mo.observe(filters, { childList: true, subtree: true });
    // Stop watching after 15s no matter what
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  // ===============================================================
  // FAB
  // ===============================================================

  function buildFab() {
    if (!isMobile()) return;
    if (document.querySelector('.nd-mobile-fab')) return;
    if (!document.querySelector('.filter-container')) return;

    var fab = document.createElement('div');
    fab.className = 'nd-mobile-fab';
    fab.innerHTML =
      '<button type="button" class="nd-mobile-fab__btn" data-nd-fab-filter aria-label="Open filters">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/>' +
          '<circle cx="8" cy="6" r="2.2" fill="currentColor"/><circle cx="16" cy="12" r="2.2" fill="currentColor"/><circle cx="10" cy="18" r="2.2" fill="currentColor"/>' +
        '</svg>' +
        '<span>Filter</span>' +
        '<span class="nd-mobile-fab__count" data-nd-fab-count hidden>0</span>' +
      '</button>';
    document.body.appendChild(fab);
    fab.querySelector('[data-nd-fab-filter]').addEventListener('click', openFilters);
    updateFilterCount();
  }

  function updateFilterCount() {
    var el = document.querySelector('[data-nd-fab-count]');
    if (!el) return;
    var applied = document.querySelectorAll('.filter-group__applied-item');
    if (!applied.length) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    el.textContent = String(applied.length);
  }

  // ===============================================================
  // Open / Close
  // ===============================================================

  function openFilters(e) {
    if (e) e.preventDefault();
    var container = document.querySelector('.filter-container');
    if (!container) return;
    // If tabs aren't built yet (slow filter load), try again now
    if (!container.classList.contains('nd-filter-tabbed')) tabify();
    container.classList.add('filter-container--show-filters-mobile');
    document.body.classList.add('nd-filter-sheet-open');
    ensureApplyBar();
  }

  function closeFilters() {
    var container = document.querySelector('.filter-container');
    if (!container) return;
    container.classList.remove('filter-container--show-filters-mobile');
    document.body.classList.remove('nd-filter-sheet-open');
  }

  // ===============================================================
  // Apply / Clear bar
  // ===============================================================

  function ensureApplyBar() {
    // Attach to <body> (NOT inside .filters) so it can't be wiped by
    // Symmetry's AJAX swaps of the filter form.
    var existing = document.querySelector('.nd-filter-apply-bar');
    if (existing) existing.remove();
    var bar = document.createElement('div');
    bar.className = 'nd-filter-apply-bar';
    bar.innerHTML =
      '<button type="button" class="nd-filter-apply-bar__clear" data-nd-clear>Reset filters</button>' +
      '<button type="button" class="nd-filter-apply-bar__apply" data-nd-apply>Apply</button>';
    document.body.appendChild(bar);
    var filtersEl = document.querySelector('.filter-container .filters');

    bar.querySelector('[data-nd-clear]').addEventListener('click', function () {
      window.ndBypassFilterBlock = true;
      var clear =
        document.querySelector('.filters__clear, a[data-clear-filters]') ||
        document.querySelector('.filter-group--applied a');
      if (clear) clear.click();
      else window.location.href = window.location.pathname;
      setTimeout(function () { window.ndBypassFilterBlock = false; }, 300);
    });
    bar.querySelector('[data-nd-apply]').addEventListener('click', applyAndClose);
  }

  // ===============================================================
  // Defer filter application until "Apply" is clicked
  // ===============================================================

  // Capture-phase listener: while the sheet is open on mobile, stop change
  // events from reaching Symmetry's AJAX handler. The DOM (checkbox/radio
  // states) still updates so the user sees their selections; only the
  // AJAX-fired side effect is suppressed.
  document.addEventListener('change', function (e) {
    if (window.ndBypassFilterBlock) return;
    if (!isMobile()) return;
    var container = document.querySelector('.filter-container');
    if (!container) return;
    if (!container.classList.contains('filter-container--show-filters-mobile')) return;
    var input = e.target;
    if (!input || !input.name) return;
    // Only block filter inputs (not unrelated form fields)
    if (input.name.indexOf('filter') !== 0) return;
    if (!input.closest('.filter-container .filters form')) return;
    // Stop other listeners (including Symmetry's) from running
    e.stopImmediatePropagation();
    e.stopPropagation();
    // Refresh tab badges live so the user sees their selection count update
    refreshTabCounts();
    // Re-render the FAB count too
    updateFilterCount();
  }, true);

  // Also refresh on price-range typing (those use 'input' events, not 'change')
  document.addEventListener('input', function (e) {
    if (!isMobile()) return;
    var input = e.target;
    if (!input || !input.matches || !input.matches('.cc-price-range__input')) return;
    if (!input.closest('.filter-container .filters')) return;
    refreshTabCounts();
  }, true);

  // Allow clicking an already-selected radio to DESELECT it. Native browsers
  // don't toggle radios. Strategy: record the radio's checked state BEFORE
  // the browser processes the click (via capture-phase mousedown/touchstart),
  // then in a post-click setTimeout, if it was already checked we uncheck it.
  function recordPreCheck(e) {
    if (!isMobile()) return;
    var item = e.target.closest && e.target.closest('.filter-container .filters .filter-group__item');
    if (!item) return;
    var radio = item.querySelector('input[type="radio"]');
    if (!radio) return;
    radio.dataset.ndPreCheck = radio.checked ? '1' : '0';
  }
  document.addEventListener('mousedown', recordPreCheck, true);
  document.addEventListener('touchstart', recordPreCheck, true);

  document.addEventListener('click', function (e) {
    if (!isMobile()) return;
    var item = e.target.closest && e.target.closest('.filter-container .filters .filter-group__item');
    if (!item) return;
    var radio = item.querySelector('input[type="radio"]');
    if (!radio) return;
    // Defer to next tick so browser's default click toggle finishes first
    setTimeout(function () {
      var was = radio.dataset.ndPreCheck;
      delete radio.dataset.ndPreCheck;
      if (was === '1' && radio.checked) {
        // It was already checked before user clicked → toggle it OFF now
        radio.checked = false;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        refreshTabCounts();
      }
    }, 10);
  });

  // On Apply: build the filter URL from the REAL form's current selections
  // and navigate to it.
  //
  // BUGFIX: the previous version did `document.querySelector('.filter-container
  // .filters form')`, which grabbed #CollectionFilterFormSkeleton (the empty
  // loading-state form that comes first in the DOM) instead of the real
  // #CollectionFilterForm. It then fired a synthetic change event at that empty
  // form, so Symmetry's AJAX read no selections and nothing applied — every
  // mobile filter silently did nothing. Navigating by URL is the canonical,
  // bullet-proof way to apply Shopify storefront filters (identical params to
  // what desktop produces, e.g. ?filter.p.product_type=Oval).
  function applyAndClose() {
    var form = findRealForm();
    if (!form) { closeFilters(); return; }
    var params = new URLSearchParams();
    // FormData on the real form yields exactly the checked radios/checkboxes,
    // non-empty price inputs, and the hidden `q` scope (search pages).
    try {
      new FormData(form).forEach(function (v, k) {
        if (v != null && String(v).length) params.append(k, v);
      });
    } catch (e) {
      // Very defensive fallback: walk inputs manually.
      form.querySelectorAll('input[name^="filter"]').forEach(function (input) {
        if (input.type === 'radio' || input.type === 'checkbox') {
          if (input.checked && input.value) params.append(input.name, input.value);
        } else if (input.value && String(input.value).length) {
          params.append(input.name, input.value);
        }
      });
    }
    // Sort lives outside the filter form — carry the current one over so
    // applying a filter doesn't reset the shopper's chosen sort order.
    if (!params.has('sort_by')) {
      var curSort = new URLSearchParams(window.location.search).get('sort_by');
      if (curSort) params.set('sort_by', curSort);
    }
    var qs = params.toString();
    window.location.href = window.location.pathname + (qs ? '?' + qs : '');
  }

  // ===============================================================
  // FAB visibility
  // ===============================================================

  function updateFabVisibility() {
    var fab = document.querySelector('.nd-mobile-fab');
    if (!fab) return;
    if (!isMobile()) { fab.classList.remove('is-visible'); return; }
    fab.classList.toggle('is-visible', window.scrollY > 220);
  }

  // ===============================================================
  // Init + lifecycle
  // ===============================================================

  // React to ANY trigger of the sheet (our FAB, Symmetry's toggle button,
  // backdrop click) by watching .filter-container's class. Track previous
  // state so we don't re-enter when our own tabify() adds nd-filter-tabbed.
  function watchSheetState() {
    var container = document.querySelector('.filter-container');
    if (!container) return;
    if (container.__ndSheetWatched) return;
    container.__ndSheetWatched = true;
    var prevOpen = container.classList.contains('filter-container--show-filters-mobile');
    var mo = new MutationObserver(function () {
      var open = container.classList.contains('filter-container--show-filters-mobile');
      if (open === prevOpen) return;          // no transition — ignore noise
      prevOpen = open;
      if (open) {
        if (!isMobile()) return;
        document.body.classList.add('nd-filter-sheet-open');
        // Defer setup so our own DOM mutations don't synchronously re-enter
        setTimeout(function () {
          tabify();
          ensureApplyBar();
          refreshTabCounts();
        }, 0);
      } else {
        document.body.classList.remove('nd-filter-sheet-open');
      }
    });
    mo.observe(container, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    if (!document.querySelector('.filter-container')) return;
    buildSortChips();
    buildFab();
    watchForFilterGroups();
    watchSheetState();
    updateFabVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('scroll', updateFabVisibility, { passive: true });
  window.addEventListener('resize', function () {
    var fab = document.querySelector('.nd-mobile-fab');
    if (!isMobile() && fab) fab.remove();
    init();
  });

  // After AJAX-filter re-render, rebuild
  document.addEventListener('on:ajax-products:updated', function () {
    buildSortChips();
    // Strip out any prior tabs and re-tabify with fresh data
    var container = document.querySelector('.filter-container');
    if (container) container.classList.remove('nd-filter-tabbed');
    var prevStrip = document.querySelector('.nd-tab-strip');
    if (prevStrip) prevStrip.remove();
    watchForFilterGroups();
    updateFilterCount();
  });
})();
